import { render } from "./WxScan.vue?vue&type=template&id=cd2f9340"
import script from "./WxScan.vue?vue&type=script&lang=js"
export * from "./WxScan.vue?vue&type=script&lang=js"

import "./WxScan.vue?vue&type=style&index=0&id=cd2f9340&lang=less"

import exportComponent from "D:\\work\\web\\sal_appgd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__